import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StraightIcon from "@mui/icons-material/Straight";
import {
  Avatar,
  Box,
  Button,
  Collapse,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { AdminRoutes } from "../../routes";
import {
  calculatePackageDuration,
  formattedDate,
  formattedTime,
  getStatus,
} from "../../utils";
import BarChart from "../Dashboard/BarChart";
import IOSSwitch from "../IsoSwitch";
import { useSelector } from "react-redux";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: appcolors.white,
      fontSize: "0.8rem",
    },

  "& .MuiTableCell-root .MuiTypography-body1 ": {
    fontSize: "0.875rem",
  },
  "&.MuiTableContainer-root": {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: appcolors.primary,
      // borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: appcolors.secondary,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: appcolors.lightGrey,
    },
  },
};

export default function DynamicTable({
  tableWidth,
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showDelete,
  handleDelete,
  showEdit,
  handleEdit,
  showCalender,
  handleLoginAsCalenderPage,
  showLogin,
  handleLoginAs,
  showDetail,
  showReviewText,
  handleNavigate,
  showPagination = true,
  showDownloadBtn,
  handleDownloadInvoice,
  handleChangeStatus,
  showMapIcon,
  showBranchChart,
  showActions,
  handleChangeCatalogueStatus,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedChartRow, setExpandedChartRow] = useState(null);
  const { branchesByBusiness } = useSelector((state) => state.branchSlices);

  const [meunAnchorEl, setMenuAnchorEl] = useState(null);
  const openAddEditMenu = Boolean(meunAnchorEl);

  const handleClickAddEditMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseAddEditMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAccordionToggle = (rowIndex) => {
    setExpandedRow(expandedRow === rowIndex ? null : rowIndex);
  };

  const handleOpenChartRow = (rowIndex) => {
    setExpandedChartRow(expandedChartRow === rowIndex ? null : rowIndex);
  };

  const IconButton = ({ children, handleClick }) => {
    return (
      <Box
        width={22}
        height={22}
        sx={{ cursor: "pointer" }}
        onClick={handleClick}
      >
        {children}
      </Box>
    );
  };

  return (
    <TableContainer sx={tableStyle}>
      <Table
        sx={{
          width: tableWidth ? tableWidth : "100%",
          // minWidth: minWidth ? minWidth : "900px",
        }}
      >
        <TableHead>
          <TableRow>
            {tableHeader?.map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
            : tableData
          )?.map((row, index) => {
            console.log(row, "rowrowrow123123");

            let a = branchesByBusiness.find((item) => {
              if (row.branchId == item?._id) {
                return item?.displayName;
              }
            });
            console.log(
              branchesByBusiness,
              "branchesByBusinessbranchesByBusiness"
            );

            console.log(a, "aaaaaaaaaaaaaaa12");

            let time = calculatePackageDuration(row.startDate, row.endDate);
            let status = getStatus(time);
            return (
              <React.Fragment key={index}>
                <TableRow>
                  {displayRows.map((val) => {
                    return (
                      <React.Fragment key={val}>
                        {val === "idAscending" ? (
                          <TableCell>{index + 1}</TableCell>
                        ) : val === "refId" ? (
                          <TableCell>#{row.refID}</TableCell>
                        ) : val === "refrence_id" ? (
                          <TableCell>#{row.refrendId}</TableCell>
                        ) : val === "date_time" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {formattedDate(row?.createdAt, false)}
                            </Typography>
                            <Typography variant="body2">
                              {formattedTime(row?.createdAt, true)}
                            </Typography>
                          </TableCell>
                        ) : val === "clients_date_time" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {moment(
                                row?.appointments[0]?.services?.startTime
                              ).format("DD-MM-YYYY hh:mm A")}
                            </Typography>
                          </TableCell>
                        ) : val === "valid_at" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {formattedDate(row.durationValid, false)}
                            </Typography>
                            <Typography variant="body2">
                              {formattedTime(row.durationValid, true)}
                            </Typography>
                          </TableCell>
                        ) : val === "price_usd" ? (
                          <TableCell>{`${row.price} SAR`}</TableCell>
                        ) : val === "branch_name" ? (
                          <TableCell> {row?.displayName}</TableCell>
                        ) : val === "branch_address" ? (
                          <TableCell>{row?.location?.address}</TableCell>
                        ) : val === "designation" ? (
                          <TableCell>{row?.jobtitle}</TableCell>
                        ) : val === "rating" ? (
                          <TableCell>{0}</TableCell>
                        ) : val === "branch_sale" ? (
                          <TableCell>{0}</TableCell>
                        ) : val === "branch_profit" ? (
                          <TableCell>{0}</TableCell>
                        ) : val === "branch_service_offered" ? (
                          <TableCell>
                            {/* {row?.type == "Both" ? "Spa & Saloon" : row?.type} */}
                          </TableCell>
                        ) : val === "person_detail" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.firstname} {row.lastname}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.email}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.contactNumber}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "client_details" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.email}/{row.contact}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.location}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "client_user_details" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.user?.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                  textTransform={"capitalize"}
                                >
                                  {row?.user?.username}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                >
                                  {row?.user?.email}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "client_service" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {` ${row.category} Categories`}
                            </Typography>
                            <Typography variant="body2">
                              {`${row.service} Services`}
                            </Typography>
                          </TableCell>
                        ) : val === "tax" ? (
                          <TableCell>{row.tax || 0}%</TableCell>
                        ) : val === "service" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {`${row.serviceName} Services`}
                            </Typography>
                          </TableCell>
                        ) : val === "services" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {`${row.service} Services`}
                            </Typography>
                          </TableCell>
                        ) : val === "membership" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {row.packageName}
                            </Typography>
                          </TableCell>
                        ) : val === "duration" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {row.duration} min
                            </Typography>
                          </TableCell>
                        ) : val === "createdBy" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {row?.createdBy == "-"
                                ? "Business"
                                : row?.createdBy}
                            </Typography>
                          </TableCell>
                        ) : val === "discount" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {row.discount || 0} %
                            </Typography>
                          </TableCell>
                        ) : val === "branch_name" ? (
                          <TableCell>{row?.branchId?.displayName}</TableCell>
                        ) : val === "client_reviews" ? (
                          <TableCell>
                            <Stack>
                              <Stack
                                gap={1}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Rating
                                  value={4}
                                  precision={0.5}
                                  max={1}
                                  readOnly
                                  size="small"
                                  color="#FF9A01"
                                />
                                <Typography variant="body2" color={"#747677"}>
                                  {`4.8 (21 Review)`}
                                </Typography>
                              </Stack>
                              {showReviewText && (
                                <Typography
                                  variant="body2"
                                  color={appcolors.primary}
                                  fontSize={"0.75rem"}
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => handleNavigate(row, index)}
                                >
                                  View All
                                </Typography>
                              )}
                            </Stack>
                          </TableCell>
                        ) : val === "status" ? (
                          <TableCell>
                            <FormGroup
                              sx={{
                                "&.MuiFormGroup-root .MuiFormControlLabel-root":
                                  {
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    justifyContent: "center",
                                  },
                                "&.MuiFormGroup-root .MuiFormControlLabel-root .MuiFormControlLabel-label ":
                                  {
                                    fontSize: "0.75rem",
                                  },
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    defaultChecked
                                    checked={row.status}
                                    onChange={() =>
                                      handleChangeStatus(row, index)
                                    }
                                  />
                                }
                                label={row.status ? "Open" : "Close"}
                              />
                            </FormGroup>
                          </TableCell>
                        ) : val === "branch_status" ? (
                          <TableCell>
                            <FormGroup
                              sx={{
                                "&.MuiFormGroup-root .MuiFormControlLabel-root":
                                  {
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    justifyContent: "center",
                                  },
                                "&.MuiFormGroup-root .MuiFormControlLabel-root .MuiFormControlLabel-label ":
                                  {
                                    fontSize: "0.75rem",
                                  },
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    defaultChecked
                                    checked={
                                      row.status == "Active" ? true : false
                                    }
                                    onChange={() =>
                                      handleChangeStatus(row, index)
                                    }
                                  />
                                }
                                label={
                                  row.status == "Active" ? "Active" : "InActive"
                                }
                              />
                            </FormGroup>
                          </TableCell>
                        ) : val === "user_details_review" ? (
                          <TableCell>
                            <Stack>
                              <Stack
                                direction={"row"}
                                justifyContent={"space-between"}
                              >
                                <Typography
                                  variant="h3"
                                  fontSize={"1rem"}
                                  fontWeight={600}
                                >
                                  {row.name}
                                </Typography>
                                <Rating
                                  value={row.review}
                                  precision={0.5}
                                  readOnly
                                  size="small"
                                  color="#FF9A01"
                                />
                              </Stack>
                              <Typography variant="body2">
                                {row.comment}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val == "show_user_Reviews" ? (
                          <TableCell>
                            <Rating
                              name="read-only"
                              value={row?.rating}
                              readOnly
                            />
                            <Typography
                              variant="h3"
                              fontSize={"1rem"}
                              fontWeight={600}
                            >
                              {row.feedback}
                            </Typography>
                          </TableCell>
                        ) : val == "showApointmentId" ? (
                          <TableCell>
                            <Typography fontSize={14}>
                              # {row.appointmentID}
                            </Typography>
                          </TableCell>
                        ) : val === "category_name" ? (
                          <TableCell>
                            <Typography
                              variant="h3"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                            >
                              {row.name}
                            </Typography>
                          </TableCell>
                        ) : val === "branch_category" ? (
                          <TableCell>
                            <Typography
                              variant="h3"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                            >
                              {row?.branchId?.displayName}
                            </Typography>
                          </TableCell>
                        ) : val === "category_description" ? (
                          <TableCell>
                            <Typography
                              variant="body1"
                              fontSize={"0.75rem"}
                              color={appcolors.gunmetal}
                              textTransform={"capitalize"}
                            >
                              {row.description.length > 150
                                ? `${row.description.slice(0, 150)}....`
                                : row.description}
                            </Typography>
                          </TableCell>
                        ) : val === "service_duration" ? (
                          <TableCell>{`${row.duration} min`}</TableCell>
                        ) : val === "service_cost" ? (
                          <TableCell>{`${row.cost} SAR`}</TableCell>
                        ) : val === "notification_title" ? (
                          <TableCell>
                            <Typography variant="body2" color={"#161C2D"}>
                              {`Title : ${row.title}`}
                            </Typography>
                          </TableCell>
                        ) : val === "notification_timer" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {formattedDate(row.timer, false)}
                            </Typography>
                            <Typography
                              variant="body2"
                              textTransform={"capitalize"}
                            >
                              {moment(row.timer).format("dddd h:m a")}
                            </Typography>
                          </TableCell>
                        ) : val === "notification_send" ? (
                          <TableCell>
                            <Box
                              onClick={() => handleNavigate(row, index)}
                              sx={{ cursor: "pointer" }}
                            >
                              <IconButton>
                                <img
                                  src={allIcons.rightArrowIcon}
                                  alt="login-icon"
                                  width={"100%"}
                                  // height={"100%"}
                                />
                              </IconButton>
                              <Typography
                                variant="body2"
                                fontSize={"0.75rem"}
                                color={
                                  row.status === "Timer" ? "#FF9A01" : "#218E06"
                                }
                              >
                                {row.status === "Timer" ? "Timer" : "send"}
                              </Typography>
                            </Box>
                          </TableCell>
                        ) : val === "subscriber_plan" ? (
                          <TableCell>
                            <Stack>
                              <Typography variant="body2">
                                <strong>Free Plan</strong> :{" "}
                                {row.subscribedPlan.free}
                              </Typography>
                              <Typography variant="body2">
                                <strong>Starter Plan</strong> :{" "}
                                {row.subscribedPlan.starter}
                              </Typography>
                              <Typography variant="body2">
                                <strong>Growth Plan</strong> :{" "}
                                {row.subscribedPlan.growth}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "earning_total" ? (
                          <TableCell>{`${row.profit} SAR`}</TableCell>
                        ) : val === "invoice_id" ? (
                          <TableCell>{`#${row.invoiceNumber}`}</TableCell>
                        ) : val === "package_duration" ? (
                          <TableCell>{`${formattedDate(
                            row.startDate,
                            false
                          )} to ${formattedDate(
                            row.endDate,
                            false
                          )} `}</TableCell>
                        ) : val === "time_duration" ? (
                          <TableCell>
                            {`${time.hours}h : ${time.minutes}min ${time.seconds}sec`}
                          </TableCell>
                        ) : val === "invoice_shop_name" ? (
                          <TableCell>
                            <Typography
                              variant="h3"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                            >
                              {row.name}
                            </Typography>
                          </TableCell>
                        ) : val === "package_name" ? (
                          <TableCell>{`${row?.planDetails[0]?.name} Package`}</TableCell>
                        ) : val === "invoice_status" ? (
                          <TableCell>
                            <Typography
                              variant="h3"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                              color={status?.color}
                            >
                              {status?.status}
                            </Typography>
                          </TableCell>
                        ) : val === "role_name" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Typography
                                variant="h3"
                                fontSize={"0.875rem"}
                                fontWeight={500}
                                color={"#000"}
                                textTransform={"capitalize"}
                              >
                                {row?.role}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "assigned_pages" ? (
                          <TableCell>
                            <Button
                              startIcon={
                                expandedRow === index ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )
                              }
                              disableRipple
                              variant="none"
                              sx={{ "&:hover": { background: "transparent" } }}
                              onClick={() => handleAccordionToggle(index)}
                            >
                              {expandedRow === index ? "Less" : "More"}
                            </Button>
                          </TableCell>
                        ) : //clients
                        val === "service_recall" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {row?.count > 1
                                ? `${row.count} times`
                                : `${row.count} time`}
                            </Typography>
                          </TableCell>
                        ) : val === "service_sale" ? (
                          <TableCell>{`${row.sale} SAR`}</TableCell>
                        ) : val === "appointment_id" ? (
                          <TableCell>{row.ref}</TableCell>
                        ) : val === "appointment_booked_date" ? (
                          <TableCell>
                            <Box>{formattedDate(row.createdDate, false)}</Box>
                            {formattedTime(row.createdDate, true)}
                          </TableCell>
                        ) : val === "appointment_shedule_date" ? (
                          <TableCell>
                            <Box>{formattedDate(row.scheduledDate, false)}</Box>
                            {formattedTime(row.scheduledDate, true)}
                          </TableCell>
                        ) : val === "appointment_duration" ? (
                          <TableCell>{`${row.duration} min`}</TableCell>
                        ) : val === "category_name" ? (
                          <TableCell>{row?.name}</TableCell>
                        ) : val === "category_descriptions" ? (
                          <TableCell>{row?.description}</TableCell>
                        ) : val === "appointment_status" ? (
                          <TableCell>
                            <Button
                              variant="none"
                              sx={{
                                height: "35px",
                                fontSize: "0.75rem",
                                color: appcolors.white,
                                boxShadow: "0px 2px 12px 0px #25334226",
                                backgroundColor:
                                  row.status === "Accepted"
                                    ? appcolors.pictonBlue
                                    : row.status === "New"
                                    ? appcolors.tumbleweed
                                    : row.status === "Cancelled"
                                    ? appcolors.redOrange
                                    : appcolors.caribbeanGreen,
                                "&:hover": {
                                  backgroundColor:
                                    row.status === "Accepted"
                                      ? appcolors.pictonBlue
                                      : row.status === "New"
                                      ? appcolors.tumbleweed
                                      : row.status === "Cancelled"
                                      ? appcolors.redOrange
                                      : appcolors.caribbeanGreen,
                                },
                              }}
                            >
                              {row.status}
                            </Button>
                          </TableCell>
                        ) : val === "username" ? (
                          <TableCell>
                            <Typography
                              variant="h1"
                              fontSize={"0.875rem"}
                              fontWeight={600}
                              color={appcolors.black}
                            >
                              User Name: {row?.firstname} {row?.lastname}
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize={"0.75rem"}
                              color={appcolors.gunmetal}
                              textTransform={"capitalize"}
                            >
                              Email: {row?.email}
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize={"0.75rem"}
                              color={appcolors.gunmetal}
                              textTransform={"capitalize"}
                            >
                              Contact: {row?.contactNumber}
                            </Typography>
                          </TableCell>
                        ) : val === "change_map" ? (
                          <TableCell>
                            <Box width={25}>
                              <img
                                src={allIcons.mapIcon}
                                alt={"map-icon"}
                                width={"100%"}
                              />
                            </Box>
                          </TableCell>
                        ) : val === "catalogue_name" ? (
                          <TableCell style={{ width: 350 }}>
                            {row.serviceName}
                          </TableCell>
                        ) : val === "catalogue_duration" ? (
                          <TableCell style={{ width: 200 }}>
                            {row.duration}
                          </TableCell>
                        ) : val === "catalogue_cost" ? (
                          <TableCell style={{ width: 200 }}>
                            {row.price} SAR
                          </TableCell>
                        ) : val === "assingedBranch" ? (
                          <TableCell style={{ width: 200 }}>
                            {row?.branchName}
                          </TableCell>
                        ) : val === "catalogue_status" ? (
                          <TableCell style={{ width: 200 }}>
                            <FormGroup
                              sx={{
                                "&.MuiFormGroup-root .MuiFormControlLabel-root":
                                  {
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                  },
                                "&.MuiFormGroup-root .MuiFormControlLabel-root .MuiFormControlLabel-label ":
                                  {
                                    fontSize: "0.75rem",
                                  },
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    defaultChecked
                                    checked={row.status}
                                    onChange={() =>
                                      handleChangeCatalogueStatus(row, index)
                                    }
                                  />
                                }
                                label={row.status ? "Open" : "Close"}
                              />
                            </FormGroup>
                          </TableCell>
                        ) : val === "actions" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              {showMapIcon && (
                                <Box width={25}>
                                  <img
                                    src={allIcons.mapIcon}
                                    alt={"map-icon"}
                                    width={"100%"}
                                  />
                                </Box>
                              )}
                              {showDelete && (
                                <IconButton
                                  handleClick={() => handleDelete(row, index)}
                                >
                                  <img
                                    src={allIcons.deleteIcon}
                                    alt="delete-icon"
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </IconButton>
                              )}
                              {showEdit && (
                                <IconButton
                                  handleClick={() => handleEdit(row, index)}
                                >
                                  <img
                                    src={allIcons.editIcon}
                                    alt="edit-icon"
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </IconButton>
                              )}
                              {showCalender && (
                                <IconButton
                                  handleClick={() =>
                                    handleLoginAsCalenderPage(row, index)
                                  }
                                >
                                  <Tooltip
                                    title={`Login as ${row.name} calender page `}
                                  >
                                    <img
                                      src={allIcons.calenderIcon}
                                      alt="calender-icon"
                                      width={"100%"}
                                      height={"100%"}
                                    />
                                  </Tooltip>
                                </IconButton>
                              )}
                              {showLogin && (
                                <IconButton
                                  handleClick={() => handleLoginAs(row, index)}
                                >
                                  <Tooltip title={`Login as ${row.name} `}>
                                    <img
                                      src={allIcons.loginIcon}
                                      alt="login-icon"
                                      width={"100%"}
                                      height={"100%"}
                                    />
                                  </Tooltip>
                                </IconButton>
                              )}
                              {showDetail && (
                                <Tooltip title={`Go to Details`}>
                                  <Box
                                    onClick={() => handleNavigate(row, index)}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <IconButton>
                                      <img
                                        src={allIcons.rightArrowIcon}
                                        alt="login-icon"
                                        width={"100%"}
                                        // height={"100%"}
                                      />
                                    </IconButton>
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      Details
                                    </Typography>
                                  </Box>
                                </Tooltip>
                              )}
                              {showBranchChart && (
                                <Tooltip title={`Go to Details`}>
                                  <Stack
                                    alignItems={"center"}
                                    onClick={() => handleOpenChartRow(index)}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    {expandedChartRow === index ? (
                                      <img
                                        src={allIcons.arrowDownIcon}
                                        alt="login-icon"
                                        width={10}
                                      />
                                    ) : (
                                      <img
                                        src={allIcons.rightArrowIcon}
                                        alt="login-icon"
                                        width={22}
                                      />
                                    )}
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      Details
                                    </Typography>
                                  </Stack>
                                </Tooltip>
                              )}
                              {showDownloadBtn && (
                                <Tooltip title={`Download this invoice`}>
                                  <Stack
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    onClick={() =>
                                      handleDownloadInvoice(row, index)
                                    }
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <StraightIcon
                                      htmlColor={appcolors.primary}
                                      sx={{ transform: "rotate(180deg)" }}
                                    />
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      Download
                                    </Typography>
                                  </Stack>
                                </Tooltip>
                              )}
                              {showActions && (
                                <>
                                  <Button
                                    disableRipple
                                    id="addEdit-menu-button"
                                    aria-controls={
                                      openAddEditMenu
                                        ? "addEdit-menu"
                                        : undefined
                                    }
                                    startIcon={
                                      <MoreVertIcon htmlColor="#000000" />
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={
                                      openAddEditMenu ? "true" : undefined
                                    }
                                    sx={{
                                      width: "auto",
                                      padding: "5px",
                                      minWidth: 0,
                                      "& .MuiButton-startIcon": {
                                        mx: 0,
                                      },
                                      "&:hover": {
                                        backgroundColor: "#ffffff",
                                      },
                                    }}
                                    onClick={handleClickAddEditMenu}
                                  ></Button>
                                  <Menu
                                    // disableScrollLock
                                    id="addEdit-menu"
                                    anchorEl={meunAnchorEl}
                                    open={openAddEditMenu}
                                    onClose={handleCloseAddEditMenu}
                                    MenuListProps={{
                                      "aria-labelledby": "addEdit-menu-button",
                                    }}
                                    sx={{
                                      ".MuiMenu-paper": {
                                        boxShadow: "none",
                                        border: "1px solid grey",
                                      },
                                    }}
                                  >
                                    <Stack
                                      direction={"row"}
                                      alignItems={"center"}
                                      spacing={1}
                                      paddingX={1}
                                    >
                                      {showEdit && (
                                        <img
                                          src={allIcons.editIcon}
                                          alt="delete-icon"
                                          width={20}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            // handleEdit(row, index);
                                            handleCloseAddEditMenu();
                                          }}
                                        />
                                      )}
                                      {showDelete && (
                                        <img
                                          src={allIcons.deleteIcon}
                                          alt="delete-icon"
                                          width={20}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            // handleDelete(row, index);
                                            handleCloseAddEditMenu();
                                          }}
                                        />
                                      )}
                                    </Stack>
                                    {/* <MenuItem
                                      onClick={handleCloseAddEditMenu}
                                      divider
                                    >
                                      <ListItemIcon>
                                        <img
                                          src={allIcons.editIcon}
                                          alt="delete-icon"
                                          width={20}
                                        />
                                      </ListItemIcon>
                                    </MenuItem>
                                    <MenuItem onClick={handleCloseAddEditMenu}>
                                      <ListItemIcon>
                                        <img
                                          src={allIcons.deleteIcon}
                                          alt="delete-icon"
                                          width={20}
                                        />
                                      </ListItemIcon>
                                    </MenuItem> */}
                                  </Menu>
                                </>
                              )}
                            </Stack>
                          </TableCell>
                        ) : (
                          <TableCell>
                            <Typography fontSize={13} lineHeight="normal">
                              {row[val]}
                            </Typography>
                          </TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={tableHeader.length}
                    style={{ padding: 0, borderBottom: "none" }}
                  >
                    <Collapse
                      in={expandedChartRow === index}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Paper elevation={2} sx={{ marginBottom: 0, padding: 2 }}>
                        <BarChart yh={"330px"} />
                      </Paper>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
      <TablePagination
        sx={{ display: showPagination ? "block" : "none" }}
        rowsPerPageOptions={[10, 25, 50, 100, { label: "All", value: -1 }]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
